import type { ValidationError } from '@atlassian/jira-fetch/src/utils/errors.tsx';
import type { InlineErrorsType } from '../../types.tsx';

export const transformToInlineErrors = (error: ValidationError): InlineErrorsType =>
	error.errors.reduce<InlineErrorsType>(
		(total, current) => ({
			// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
			...total,
			[current.field]: current.error,
		}),
		{},
	);
